export const AUTH_COOKIES = {
  idToken: 'RAKID.idToken',
  accessToken: 'RAKID.accessToken',
  refreshToken: 'RAKID.refreshToken',
  isUserActive: 'RAKID.isUserActive',
};
